import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, AfterViewInit, signal } from '@angular/core';
import { DevolucionesService } from './service/devoluciones.service';
import { DevoluciónDineroResponse, DevoluciónDineroData } from './interfaces/devoluciones.interface';
import { SolicitarDevolucionComponent } from "./components/solicitar-devolucion/solicitar-devolucion.component";
import { LoadImagesService } from '../../../../core/service/load-image.service';

@Component({
  selector: 'perfil-user-devoluciones',
  imports: [CommonModule, SolicitarDevolucionComponent],
  templateUrl: './devoluciones.component.html',
  styleUrl: './devoluciones.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevolucionesComponent implements OnInit, AfterViewInit {
  devoluciones: DevoluciónDineroData[] = [];
  isLoading = true;
  hasError = false;
  errorMessage = '';
  urlImage = signal('');
  readonly defaultImage = 'assets/imagen_default.png';
  @ViewChild('solicitarDevolucion', { static: false }) solicitarDevolucion!: SolicitarDevolucionComponent;
  constructor(
    private devolucionesService: DevolucionesService,
    private cdr: ChangeDetectorRef,
    private imageService: LoadImagesService,
  ) {


  }

  ngOnInit(): void {
    this.loadDevoluciones();
  }

  ngAfterViewInit(): void {
    // ViewChild está disponible después de que la vista se inicializa
    // console.log('ViewChild inicializado:', this.solicitarDevolucion);
  }

  loadDevoluciones(): void {
    this.isLoading = true;
    this.hasError = false;
    this.cdr.markForCheck();

    this.devolucionesService.loadDevoluciones().subscribe({
      next: (res: DevoluciónDineroResponse) => {
        this.devoluciones = res.data || [];
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.hasError = true;
        this.errorMessage = 'Error al cargar las devoluciones';
        this.isLoading = false;
        this.cdr.markForCheck();
        console.error(err);
      }
    });
  }

  getStatusText(status: string): string {
    const statusMap: { [key: string]: string } = {
      'pending': 'Pendiente',
      'approved': 'Aprobada',
      'rejected': 'Rechazada',
      'completed': 'Completada'
    };
    return statusMap[status] || status;
  }

  getStatusClass(status: string): string {
    const statusClasses: { [key: string]: string } = {
      'pending': 'status-pending',
      'approved': 'status-approved',
      'rejected': 'status-rejected',
      'completed': 'status-completed'
    };
    return statusClasses[status] || 'status-default';
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      currencyDisplay: 'symbol'
    }).format(amount);
  }

  trackByOrderId(index: number, item: DevoluciónDineroData): number {
    return item.id_order;
  }

  viewDetails(devolucion: DevoluciónDineroData): void {
    // TODO: Implementar navegación a detalles o modal
    // console.log('Ver detalles de la devolución:', devolucion);
  }


  requestRefund(devolucion: DevoluciónDineroData): void {
    if (!this.solicitarDevolucion) {
      console.error('El componente solicitar-devolucion no está disponible');
      return;
    }

    this.solicitarDevolucion.idOrden = devolucion.id_order;
    this.solicitarDevolucion.openModal();
  }


  getImageUrl(pathPicture: string) {

    if (!pathPicture) {
      return this.defaultImage;
    }

    // Check if the image path is already a full URL or an asset path
    if (pathPicture.startsWith('http') || pathPicture.startsWith('assets/')) {
      return pathPicture;
    }
    return this.imageService.linkImage + pathPicture;

  }

  onImageError(event: any): void {
    event.target.src = this.defaultImage;
  }
}
